module.exports = __webpack_public_path__ + "img/transition-1.4c0cf977.png";